<template>
  <div>
    <div class="popup-tip">
      <p class="popup-tip__title">弹窗公告</p>
      <p class="popup-tip__subtitle">
        占位，可点击右侧弹窗状态打开预览此模块。
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "PopupPreview",
  data() {
    return {
      centerDialogVisible: true
    }
  }
}
</script>

<style lang="scss" scoped>
.popup-tip {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 70px;
  margin: 0 auto;
  background-color: #fff;
  overflow: hidden;

  &__title {
    font-size: 15px;
    text-align: center;
  }

  &__subtitle {
    font-size: 12px;
    color: #999999;
    margin-top: 10px;
    text-align: center;
  }
}
</style>